import styled from 'styled-components';
import Form from 'react-bootstrap/Form';

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '2.5rem')};
  background-color: ${(props) => props.theme.white};
  border: 1.5px solid ${(props) => props.theme.secondaryColorDark};
  border-radius: ${(props) => props.theme.borderRadius};
  overflow: hidden;

  &:focus-within {
    border-color: ${(props) => props.theme.secondaryColor};
    box-shadow: 0 0 0 0.2rem ${(props) => props.theme.focusShadow};
  }

  ${(props) =>
    props.disabled &&
    `
    background-color: ${props.theme.disabledBg};
    border: 1.5px solid ${props.theme.disabledBg};
    cursor: not-allowed;
  `}

  @media only screen and (min-width: 1101px) {
    ${(props) =>
      props.question && props.question == 'role2' ? 'display: none' : null};
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    ${(props) =>
      props.question && props.question == 'role1' ? 'display: none' : null};
  }
`;

export const Affix = styled.span`
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.grayDark};
  user-select: none;
  white-space: nowrap;
`;

export const StyledTextInput = styled(Form.Control)`
  background-color: ${(props) => props.theme.white};
  border: 1.5px solid ${(props) => props.theme.secondaryColorDark};
  border-radius: ${(props) => props.theme.borderRadius};
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '2.5rem')};
  display: ${(props) => (props.display ? props.display : 'flex')};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-size: ${(props) => props.theme.fontSizeBase};
  padding: 0 0.6rem;

  &:disabled {
    background-color: ${(props) => props.theme.disabledBg};
    border: 1.5px solid ${(props) => props.theme.disabledBg};
    cursor: not-allowed;
  }

  @media only screen and (min-width: 1101px) {
    ${(props) =>
      props.question && props.question == 'role2' ? 'display: none' : null};
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    ${(props) =>
      props.question && props.question == 'role1' ? 'display: none' : null};
  }
`;

export const StyledWrappedInput = styled(Form.Control)`
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
  font-size: ${(props) => props.theme.fontSizeBase};
  height: 100%;

  &:focus {
    box-shadow: none;
    background-color: transparent;
  }

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }
`;
